module.exports = __webpack_public_path__ + "img/banner-trade-in.fa2e060b.jpg";